/// <reference path="../../TypeLite.Net4.d.ts" />
import { action } from 'typesafe-actions';
import { FilterActionTypes, WizardFilterActionPayload, CountryFilterActionPayload } from './types';

export const applyCountryFilter = (countryFilterActionPayload: CountryFilterActionPayload) => action(FilterActionTypes.APPLY_CountryFilter, countryFilterActionPayload);
export const applyWizardFilter = (wizardFilterActionPayload: WizardFilterActionPayload) => action(FilterActionTypes.APPLY_WizardFilter, wizardFilterActionPayload);
export const resetAll = () => action(FilterActionTypes.RESET_All);


